<template>
  <div class="root">
    <div class="header">
      <router-link to="/" tag="button" class="back-btn">
        <img class="back-btn-img" src="@/assets/checkout/arrow-left.svg" />
        <!-- <span class="back-btn-text">QUAY LẠI</span> -->
      </router-link>
      <div class="timerArea">
        <span class="timerText">Ưu đãi còn:</span>
        <span class="timer">
          {{ timeDisplay.hours[0] }}{{ timeDisplay.hours[1]
          }}<span class="unit">h</span> <span class="seperator">:</span>
          {{ timeDisplay.minutes[0] }}{{ timeDisplay.minutes[1]
          }}<span class="unit">m</span> <span class="seperator">:</span>
          {{ timeDisplay.seconds[0] }}{{ timeDisplay.seconds[1]
          }}<span class="unit">s</span>
        </span>
      </div>
    </div>
    <div class="content">
      <div class="leftbox">
        <div class="benefits">
          <div class="benefit">
            <img
              class="benefit-image"
              src="@/assets/checkout/shipping.svg"
              width="32"
              height="20"
            />
            <span class="benefit-text">MIỄN PHÍ VẬN CHUYỂN TOÀN QUỐC</span>
          </div>
          <div class="benefit">
            <img
              class="benefit-image"
              src="@/assets/checkout/warranty.svg"
              width="32"
              height="20"
            />
            <span class="benefit-text">{{
              `1 ĐỔI 1 TRONG VÒNG 3 NGÀY,\nBẢO HÀNH 10 NĂM`
            }}</span>
          </div>
        </div>
        <img
          :src="selectedVariant.thumbnail"
          alt="thumbnail"
          class="selected-product-thumbnail"
        />
        <div class="bottom-divider"></div>
      </div>
      <div class="rightbox" v-if="!isSubmitSuccess">
        <div class="choose-variant-prompt">Chọn phối màu ưa thích của bạn</div>

        <VariantSelector align="left" />
        <div class="variant-info">
          <div class="name">{{ selectedVariant.name }}</div>
          <div class="vertical-divider"></div>
          <div class="prices">
            <span class="discounted">{{
              selectedVariant.priceDiscounted | priceVndFormat
            }}</span>
            <span class="original">{{
              selectedVariant.price | priceVndFormat
            }}</span>
          </div>
        </div>
        <div class="bottom-divider"></div>

        <div class="order-form">
          <loading :active.sync="isSubmitting" :is-full-page="false"></loading>
          <FormulateForm v-model="formValues" @submit="submitForm">
            <FormulateInput
              class="form-input"
              type="text"
              name="name"
              placeholder="Họ tên"
              validation="bail|required|min:2"
              :validation-messages="{
                required: 'Không được để trống họ tên.',
                min: 'Họ tên quá ngắn.',
              }"
            />
            <FormulateInput
              class="form-input"
              type="email"
              name="email"
              placeholder="Email"
              validation="bail|required|email"
              :validation-messages="{
                required: 'Không được để trống email.',
                email: 'Email không hợp lệ.',
              }"
            />
            <FormulateInput
              class="form-input"
              type="text"
              name="phone"
              placeholder="Số điện thoại"
              validation="bail|required|isPhone"
              :validation-rules="formValidationRules"
              :validation-messages="{
                required: 'Không được để trống số điện thoại.',
                isPhone: 'Số điện thoại không hợp lệ.',
              }"
            />
            <FormulateInput
              class="form-input"
              type="text"
              name="address"
              placeholder="Địa chỉ giao hàng"
              validation="bail|required"
              :validation-messages="{
                required: 'Không được để trống địa chỉ giao hàng.',
              }"
            />

            <FormulateInput
              class="form-submit-btn"
              type="submit"
              label="PRE-ORDER NGAY"
              :disabled="isSubmitting"
            />
          </FormulateForm>
        </div>
      </div>
      <div class="rightbox" v-else>
        <success-checkout :values="orderData" />
      </div>
    </div>
    <div class="benefits benefits-desktop">
      <div class="benefit">
        <img
          class="benefit-image"
          src="@/assets/checkout/shipping.svg"
          width="32"
          height="20"
        />
        <span class="benefit-text">MIỄN PHÍ VẬN CHUYỂN TOÀN QUỐC</span>
      </div>
      <div class="benefit">
        <img
          class="benefit-image"
          src="@/assets/checkout/warranty.svg"
          width="32"
          height="20"
        />
        <span class="benefit-text">{{
          `1 ĐỔI 1 TRONG VÒNG 3 NGÀY,\nBẢO HÀNH 10 NĂM`
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import VariantSelector from "@/components/variantSelector/variantSelector";
import SuccessCheckout from "@/components/checkout/success";
import { mapGetters } from "vuex";
import Loading from "vue-loading-overlay";
import axios from "axios";
import phone from "phone";
import dayjs from "dayjs";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  name: "checkout",
  components: { VariantSelector, Loading, SuccessCheckout },
  computed: {
    ...mapGetters({
      selectedVariant: "selectedVariant",
    }),
  },
  methods: {
    getTimeCountdown() {
      let distanceInSeconds = dayjs(this.deadlineTime).diff(dayjs(), "second");
      let seconds = distanceInSeconds % 60;
      let minutes = Math.ceil(distanceInSeconds / 60) % 60;
      let hours = Math.ceil(distanceInSeconds / 3600);
      return {
        seconds: [Math.floor(seconds / 10), seconds % 10],
        minutes: [Math.floor(minutes / 10), minutes % 10],
        hours: [Math.floor(hours / 10), hours % 10],
      };
    },
    async submitForm(values) {
      this.isSubmitting = true;
      const postResult = await axios.post(
        "https://landing-pages-api.dtx.asia/order",
        {
          name: values.name,
          phone: values.phone,
          address: values.address,
          email: values.email,
          product: this.selectedVariant.name,
          table: "Florenge",
          url: window.location.href,
          source: "florenge landing page",
        }
      );
      this.isSubmitting = false;
      if (
        postResult.data &&
        postResult.data.length == 3 &&
        postResult.data[2].code == 0
      ) {
        this.isSubmitSuccess = true;
        this.$gtag.event("purchase", {
          affiliation: "Florenge Pre-Order Page",
          value: this.selectedVariant.priceDiscounted,
          currency: "VND",
          items: [
            {
              id: this.selectedVariant.id,
              name: this.selectedVariant.name,
              price: this.selectedVariant.priceDiscounted,
              quantity: 1,
            },
          ],
        });
        window.fbq("track", "Purchase", {
          currency: "VND",
          value: 2149000,
        });
        this.orderData = values;
      }
      return true;
    },
  },
  data() {
    const endTime = dayjs().add(1,'d');
    return {
      timerInterval: null,
      deadlineTime: endTime.valueOf() - 11 * 3600 * 1000,
      timeDisplay: { hours: [], minutes: [], seconds: [] },
      isSubmitting: false,
      isSubmitSuccess: false,
      formValidationRules: {
        isPhone(context) {
          return phone(context.value, "VN").length > 0;
        },
      },
      formValues: {},
      orderData: {},
    };
  },
  mounted() {
    this.$gtag.pageview({
      page_path: "/checkout",
    });
    this.$gtag.event("checkout", {});
    window.fbq("track", "InitiateCheckout");
    this.timeDisplay = this.getTimeCountdown();
    this.timerInterval = setInterval(() => {
      this.timeDisplay = this.getTimeCountdown();
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.timerInterval);
  },
};
</script>
<style lang="scss">
.order-form {
  position: relative;
  .formulate-input-errors {
    font-family: "SVN-Gotham", sans-serif;
    list-style-type: none;
    padding: 0;
    padding-top: 16px;
    margin: 0;
    font-size: 12px;
    line-height: 24px;
  }
  .form-input {
    padding: 8px 16px;
    input {
      min-width: 100%;
      background: #FFFFFF;
      border: 1px solid rgba(0, 0, 0, 0.15);
      box-sizing: border-box;
      padding: 16px;
      font-family: "SVN-Gotham", sans-serif;
      font-style: normal;
      font-weight: 300;
      font-size: 16px;
      line-height: 16px;
      /* identical to box height, or 100% */

      display: flex;
      align-items: center;
      letter-spacing: 0.03em;

      color: rgba(0, 0, 0, 0.6);
    }
    &[data-is-showing-errors="true"] {
      input {
        border-color: #D35C34;
      }
    }
  }
  .form-submit-btn {
    padding: 16px;
    button {
      cursor: pointer;
      border: none;
      min-width: 100%;
      background: #D35C34;
      font-family: "SVN-Gotham", sans-serif;
      padding: 24px;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 16px;
      /* identical to box height, or 100% */

      text-align: center;
      letter-spacing: 0.03em;

      color: #FFFFFF;
    }
  }
}
@media (min-width: 1024px) {
  .root {
    .form-submit-btn {
      max-width: 65%;
    }
  }
}
</style>
 <style lang="scss" scoped>
.bottom-divider {
  height: 1px;
  background: linear-gradient(
    90deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.15) 50%,
    rgba(0, 0, 0, 0) 100%
  );
}
.root {
  background: #FAF7F1;
  .header {
    padding: 16px 24px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
    display: flex;
    flex-direction: row;
    .back-btn {
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      background: transparent;
      border: none;
      .back-btn-text {
        font-family: "SVN-Gotham", sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 16px;
        letter-spacing: 0.03em;
        color: rgba(0, 0, 0, 0.6);
      }
      .back-btn-img {
        margin-right: 16px;
      }
    }
    .timerArea {
      width: 100%;
      text-align: center;
      font-family: "SVN-Gotham", sans-serif;

      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 16px;

      color: #000000;
      .timer {
        font-weight: 500;
        font-size: 20px;
        line-height: 20px;

        color: #D35C34;
        .unit {
          font-size: 12px;
        }
        .seperator {
          font-size: 14px;
          /* font-weight: normal; */
          color: #000000;
        }
      }
    }
  }
  .leftbox {
    padding: 32px 16px;
  }
  .rightbox {
    .choose-variant-prompt {
      font-family: "SVN-Gotham", sans-serif;

      font-style: normal;
      font-weight: 300;
      font-size: 16px;
      line-height: 16px;
      /* identical to box height, or 100% */

      text-align: center;
      letter-spacing: 0.03em;

      color: #000000;
      margin-bottom: 24px;
    }
    .variant-info {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 24px 16px;
      .vertical-divider {
        margin-left: 16px;
        margin-right: 16px;
        width: 1px;
        height: 30px;
        background: linear-gradient(
          0deg,
          rgba(0, 0, 0, 0) 0%,
          rgba(0, 0, 0, 0.15) 50%,
          rgba(0, 0, 0, 0) 100%
        );
      }
      .name {
        font-family: "SVN-Gotham", sans-serif;
        text-transform: uppercase;
        font-style: normal;
        font-weight: normal;
        font-size: 20px;
        line-height: 20px;
        /* identical to box height, or 100% */

        color: #000000;
      }

      .prices {
        display: flex;
        flex-direction: column;
        .discounted {
          font-family: "SVN-Gotham", sans-serif;
          font-style: normal;
          font-weight: 500;
          font-size: 20px;
          line-height: 20px;
          /* identical to box height, or 100% */

          letter-spacing: 0.03em;

          color: #D35C34;
        }
        .original {
          font-family: "SVN-Gotham", sans-serif;
          font-style: normal;
          font-weight: 500;
          font-size: 10px;
          line-height: 10px;
          /* identical to box height, or 100% */

          text-align: right;
          letter-spacing: 0.03em;
          text-decoration-line: line-through;

          color: rgba(0, 0, 0, 0.6);
        }
      }
    }
    .order-form {
      padding: 40px 0;
    }
  }
  .benefits {
    .benefit {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 12px;
      .benefit-image {
        width: 32px;
        object-fit: contain;
      }
      .benefit-text {
        margin-left: 16px;
        font-family: "SVN-Gotham", sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        letter-spacing: 0.03em;
        color: #000000;
        white-space: pre-wrap;
      }
    }
  }
  .selected-product-thumbnail {
    width: 100%;
    max-height: 100vw;
    object-fit: contain;
    object-position: center;
  }
  .benefits-desktop {
    display: none;
  }
}
@media (min-width: 1024px) {
  .root {
    display: flex;
    min-height: 100vh;
    flex-direction: column;
    .content {
      flex: 1;
      display: flex;
      flex-direction: row;
      min-width: 1024px;
      align-self: center;
      align-items: center;
      .leftbox {
        flex: 1;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        .selected-product-thumbnail {
          max-width: 360px;
          max-height: 360px;
        }
        .bottom-divider {
          width: 1px;
          height: 500px;
          background: linear-gradient(
            0deg,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0.15) 50%,
            rgba(0, 0, 0, 0) 100%
          );
        }
      }
      .rightbox {
        flex: 1;
        .choose-variant-prompt {
          text-align: left;
          padding: 0 16px;
        }
        .variant-info {
          justify-content: flex-start;
        }
      }
    }
    .benefits {
      display: none;
    }
    .benefits-desktop {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      margin-bottom: 42px;
      .benefit {
        .benefit-text {
          white-space: normal;
        }
      }
    }
  }
}
</style>